import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-[#F3F5F7]" data-id="element-82" data-mp="3djueifd6yagl">
      <div className="max-w-5xl mx-auto" data-id="element-83" data-mp="3dkm9pp2vm66c">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#16191E] text-center mb-12 uppercase" data-id="element-84" data-mp="3ij70yz05hfin">
          Everything Included in <span className="text-[#E8590C]" data-id="element-85" data-mp="3mlttz38k56hf">Welding Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-86" data-mp="xtpy8bnqwv03">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-[#16191E] border-b-4 border-[#F28A2E] rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-87" data-mp="11t8ntkqihu99">
              <Icon size={28} className="text-[#FF9A4D]" aria-hidden="true" data-id="element-88" data-mp="1dag82nwi1dhn" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-89" data-mp="18bd2n2clx595">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-90" data-mp="zayelv89dc1y">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-[#D5DAE0] rounded-xl p-4 flex items-center gap-3" data-id="element-91" data-mp="uj6x0a72ygny">
              <span className="w-9 h-9 rounded-lg bg-[#16191E] text-[#FF9A4D] flex items-center justify-center shrink-0" data-id="element-92" data-mp="km29o71i0f5k">
                <Icon size={18} aria-hidden="true" data-id="element-93" data-mp="gkysnh7psd2r" />
              </span>
              <span className="text-[#16191E] font-bold text-xs uppercase leading-tight" data-id="element-94" data-mp="gma0pt8706zo">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-[#16191E] rounded-3xl p-8 md:p-12 shadow-xl shadow-[#16191E]/10 text-center" data-id="element-95" data-mp="1wp1bxij8v27">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-96" data-mp="3t65p528p8lm3" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#16191E] mb-1" data-id="element-97" data-mp="pmt6487gj0us">
            WELDING INSTRUCTOR <span className="text-[#E8590C]" data-id="element-98" data-mp="awc5us6k6gzh">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-[#B8480A] mb-3" data-id="element-99" data-mp="fw87wlvp3yce">
            The Complete 6-IN-1 Visual Welding Technology &amp; Technical Training System for Welding Instructors, Technical Schools &amp; Training Workshops
          </p>
          <p className="text-base text-slate-700/80 max-w-2xl mx-auto mb-8" data-id="element-100" data-mp="18fncweuxfmnx">
            A complete visual training system created to help welding instructors plan, explain, demonstrate
            and assess every core welding skill with more clarity, structure and confidence.
          </p>
          <p className="text-sm font-bold tracking-widest text-[#16191E] mb-1" data-id="element-101" data-mp="31ydu31eebrn3">YOUR PRICE:</p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#E8590C] mb-6" data-id="element-102" data-mp="2xx2apdm482nc">
            {PRICE_LABEL}
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-103" data-mp="256tpte073452">
            {PRIMARY_CTA}
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-104" data-mp="2e6p59v0s9law">
            Immediate Access · 6 Visual Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-[#D5DAE0]" data-id="element-105" data-mp="3unbb716vfie9">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-[#16191E] mb-2 uppercase" data-id="element-106" data-mp="3pl3w42qqvm7p">
              Stop Planning Every Welding Class From Scratch.
            </p>
            <p className="text-lg font-semibold text-[#B8480A]" data-id="element-107" data-mp="tp7kzp4pywn4">OPEN IT. CHOOSE IT. SHOW IT. TEACH IT.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}